export enum ReviewOutcomes {
    Pass = 1,
    Fail = 2,
    NeedsReview = 3,
}
